var module = angular.module('octopusApp.projects');
import React from 'react';

TemplateSummary.propTypes = {
    name: React.PropTypes.string.isRequired,
    author: React.PropTypes.string.isRequired,
    version: React.PropTypes.number.isRequired,
    websiteUrl: React.PropTypes.string.isRequired,
    onCancel: React.PropTypes.func.isRequired,
    cancelButtonName: React.PropTypes.string,
    onUpdate: React.PropTypes.func.isRequired,
    updateButtonName: React.PropTypes.string,
    onInstall: React.PropTypes.func.isRequired,
    installButtonName: React.PropTypes.string,
    isUpdateAvailable: React.PropTypes.bool.isRequired,
    descriptionHtml: React.PropTypes.object.isRequired
};

function TemplateSummary(props){
    return <div>
        <div className="template-summary-container">
            <div className="margin-bottom-5">
                <h3>{props.name}</h3>
                <div className="template-external-resources">
                    <span><strong>Version {props.version}</strong></span>
                    <span className="divider">|</span>
                    <span>By <a href={'https://github.com/' + props.author} target="_blank">{props.author}</a> <i className="fa fa-users template-icon" aria-hidden="true"></i></span>
                    <span className="divider">|</span>
                    <span><a href={props.websiteUrl} target="_blank">View website</a> <i className="fa fa-globe template-icon" aria-hidden="true"></i></span>
                </div>
            </div>
            <div className="template-button-container">
                <button type="button" className="btn btn template-button" onClick={props.onCancel}>{ props.cancelButtonName ? props.cancelButtonName : 'Cancel'}</button>
                {!props.isUpdateAvailable ? <button type="button" className="btn btn-success template-button" onClick={props.onInstall}>{props.installButtonName ? props.installButtonName : 'Install and add step' }</button> : null}
                {props.isUpdateAvailable ? <button type="button" className="btn btn-success template-button" onClick={props.onUpdate}>{props.updateButtonName ? props.updateButtonName : 'Update and add step'}</button> : null}
            </div>
        </div>
        <hr className="no-margin-t" />
        <div dangerouslySetInnerHTML={props.descriptionHtml}></div>
    </div>;
};

export default TemplateSummary;



// WEBPACK FOOTER //
// ./app/areas/library/steps/views/template_summary.jsx